import React from 'react';
import Slider from 'rc-slider';

import { IHandleProps } from '../../../types/timeline';

import './range-with-inputs.scss';

const { Range, Handle } = Slider;

interface IRangeWithInputsProps {
  layer: any;
  rangeValues: Array<number>;
  min: number;
  max: number;
  onChangeFunction: Function;
  step: number;
}

const RangeWithInputs = ({ layer, rangeValues, onChangeFunction, step, min, max }: IRangeWithInputsProps) => {
  const marks = {
    [Number(min.toFixed(2))]: 'Loss',
    0: 'No Difference',
    [Number(max.toFixed(2))]: 'Gain',
  };

  const handle = (props: IHandleProps) => {
    const { value, dragging, index, ...restProps } = props;
    return (
      <Handle key={index} value={value} {...restProps}>
        <div className='inner'>
          <div className={`range-tooltip${dragging ? ' active' : ''}`}>
            <span className='range-tooltip-inner'>
              {analysisType()} Difference: {value}
            </span>
          </div>
        </div>
      </Handle>
    );
  };

  const analysisType = () => {
    if (layer.title.includes('NDVI')) {
      return 'NDVI';
    } else if (layer.title.includes('GNDVI')) {
      return 'GNDVI';
    } else if (layer.title.includes('EVI')) {
      return 'EVI';
    } else {
      return 'SAVI';
    }
  };

  return (
    <div className='range-with-inputs-container'>
      <div className='range-input'>
        <Range
          className={'range-slider'}
          value={rangeValues}
          min={Number(min.toFixed(2))}
          max={Number(max.toFixed(2))}
          step={step}
          handle={handle}
          handleStyle={[{ borderColor: '#295C4D' }, { borderColor: '#295C4D' }]}
          railStyle={{
            background: `linear-gradient(to right, #ff0000 ${((rangeValues[0] - min) / (max - min)) * 100}%, #00ff00 ${
              ((rangeValues[1] - min) / (max - min)) * 100
            }%)`,
          }}
          onChange={(values: Array<number>) => onChangeFunction(values)}
          marks={marks}
        />
      </div>
    </div>
  );
};

export default RangeWithInputs;
